export { w as ComponentBuilder, a7 as ComponentViewBuilder, t as ConfirmDeleteDialog, T as DEFAULT_INTENT_HANDLER, p as DeskToolProvider, x as DocumentBuilder, A as DocumentListBuilder, F as DocumentListItemBuilder, I as DocumentTypeListBuilder, a6 as FormViewBuilder, K as GenericListBuilder, a8 as GenericViewBuilder, a2 as HELP_URL, M as InitialValueTemplateItemBuilder, V as ListBuilder, W as ListItemBuilder, Y as MenuItemBuilder, a1 as MenuItemGroupBuilder, S as SerializeError, a5 as component, a3 as createStructureBuilder, N as defaultInitialValueTemplateItems, U as defaultIntentChecker, v as deskTool, y as documentFromEditor, z as documentFromEditorWithInitialValue, a4 as form, Z as getOrderingMenuItem, $ as getOrderingMenuItemsForSchemaType, E as getTypeNamesFromFilter, G as isDocumentListItem, O as maybeSerializeInitialValueTemplateItem, X as maybeSerializeMenuItem, a0 as maybeSerializeMenuItemGroup, a9 as maybeSerializeView, Q as menuItemsFromInitialValueTemplateItems, J as shallowIntentChecker, u as useDocumentPane, i as usePaneRouter } from './_chunks/desk-4ed64687.esm.js';
import 'react/jsx-runtime';
import 'react';
import 'sanity';
import '@sanity/icons';
import '@sanity/ui';
import 'sanity/router';
import '@sanity/types';
import 'lodash/omit.js';
import '@sanity/util/paths';
import 'lodash/isNumber.js';
import 'lodash/isString.js';
import 'react-rx';
import 'styled-components';
import 'rxjs';
import 'rxjs/operators';
import 'react-copy-to-clipboard';
import 'lodash/partition.js';
import 'lodash/uniqBy.js';
import '@sanity/uuid';
import 'lodash/camelCase.js';
import 'lodash/uniq.js';
import 'lodash/kebabCase.js';
import 'lodash/pickBy.js';
import 'lodash/find.js';
import 'lodash/uniqueId.js';
import 'react-is';
import 'lodash/startCase.js';
//# sourceMappingURL=desk.esm.js.map
